import axios from "axios";
import { useState } from "react";
import SignIn from "./sign-in/SignIn";

function Login(props)
{
    return(
    <>
        <SignIn token={props.token} setToken={props.setToken} admin={props.admin} setAdmin={props.setAdmin} refreshCompanies={props.refreshCompanies}></SignIn>
    </>
    );
}

export default Login;